<template>
  <search-layout class="eproposal-sms" :header="!type ? '短信验证' : ''">
    <div v-if="!!type" slot="header" class="header">
      根据当地行业监管规定，车险支付需对您的手机号进行短信验证！
    </div>
    <page-status :loading="loading">
      <div class="auth-content">
        <div class="auth-title">我们将发送短信验证码到你的手机号</div>
        <div class="auth-mobile">
          {{ mobile.slice(0, 3) + '****' + mobile.slice(7, 13) }}
        </div>
        <div class="verify-code">
          <van-password-input
            :gutter="16"
            :mask="false"
            :length="smsMaxLength"
            :value="code"
            :focused="focused"
          />
          <input
            class="input-code"
            type="tel"
            :maxlength="smsMaxLength"
            v-model="code"
            @focus="focused = true"
            @blur="focused = false"
          />
        </div>
        <div v-if="canSend" class="send-code active" @click="handleSend()">
          发送验证码
        </div>
        <div v-else class="send-code">
          <van-count-down
            ref="countDown"
            :time="smsSecond"
            format="ss"
            @finish="handleFinish()"
          />
          <span>秒后重新发送</span>
        </div>
      </div>
    </page-status>
  </search-layout>
</template>

<script>
import { Toast } from 'vant';
import SearchLayout from '@/layouts/SearchLayout';
import PageStatus from '@/components/PageStatus';
import * as services from '@/services';
import { bindRecord } from '@/core/recorder';

export default {
  components: {
    SearchLayout,
    PageStatus,
  },

  data() {
    return {
      loading: true,
      mobile: '',
      smsAuthNo: '',
      smsMaxLength: 4,
      smsSecond: 120000,
      canSend: true,
      focused: false,
      code: '',
      type: '',
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const { businessNo, mobile, type } = this.$route.query;

      this.type = type;

      // 绑定用户
      if (businessNo && mobile) {
        bindRecord({ userId: businessNo + '_' + mobile });
      }

      services
        .authConfig(businessNo, mobile)
        .then(res => {
          const { payed, smsMaxLength, smsSecond } = res.content;
          if (payed === '1') {
            const query = { businessNo, mobile };
            this.$router.replace({ path: '/insure-result', query });
          } else {
            this.smsMaxLength = parseInt(smsMaxLength) || 4;
            this.smsSecond = parseInt(smsSecond) * 1000 || 120000;
            this.mobile = mobile;
            this.loading = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleSend() {
      this.sendAuthSms();
    },

    handleFinish() {
      this.canSend = true;
    },

    sendAuthSms() {
      Toast.loading({
        message: '正在发送',
        forbidClick: true,
        duration: 0,
      });

      const { businessNo, mobile, flag } = this.$route.query;
      services.sendPhoneMessage(businessNo, mobile).then(res => {
        if (res) {
          const payed = res.content;
          const { failCause } = res;
          if (payed === '1') {
            const query = { businessNo, mobile };
            this.$router.replace({ path: '/insure-result', query });
          } else if (failCause) {
            Toast({ message: failCause, duration: 3000 });
          } else {
            this.canSend = false;
            Toast.success('发送成功');
          }
        }
      });
    },

    checkAuthSms() {
      Toast.loading({
        message: '正在验证',
        forbidClick: true,
        duration: 0,
      });

      const codeNo = this.code;
      const { businessNo, mobile, code } = this.$route.query;

      services.checkMessageCode(businessNo, mobile, codeNo).then(res => {
        const { content, failCause } = res;
        if (res && content) {
          const newUrl = code ? `${content}&code=${code}` : content;
          window.location.replace(newUrl);
        }
        if (failCause) {
          Toast({ message: failCause, duration: 3000 });
        }
      });
    },
  },

  watch: {
    code(value) {
      this.code = value.slice(0, this.smsMaxLength).replace(/\D/g, '');
      if (this.code.length === this.smsMaxLength) {
        this.checkAuthSms();
      }
    },
  },
};
</script>

<style lang="less">
.eproposal-sms {
  .header {
    font-size: 20px;
    line-height: 1.5;
  }
  .auth-content {
    padding: 24px 12px;
    text-align: center;

    .auth-title {
      color: #9b9b9b;
    }

    .auth-mobile {
      margin-top: 12px;
      color: #4a4a4a;
      font-size: 24px;
    }

    .verify-code {
      margin-top: 24px;
      position: relative;

      .van-password-input {
        li {
          border-radius: 4px;
          border: 1px solid #dcdcdc;
        }
      }

      .input-code {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        opacity: 0;
      }
    }

    .send-code {
      margin-top: 12px;
      padding: 12px 0;
      color: #9b9b9b;
      font-size: 16px;

      .van-count-down {
        display: inline-block;
        font-size: 16px;
      }

      &.active {
        background-image: linear-gradient(136deg, #3a91ec 0%, #426ed9 100%);
        box-shadow: 0rpx 16rpx 30rpx -20rpx #4677d9;
        width: 320px;
        height: 24px;
        margin: 48px auto;
        border-radius: 4px;
        color: #fff;
      }
    }
  }
}
</style>
